import { render } from "./SubmitBtn.vue?vue&type=template&id=bb1d099c&scoped=true"
import script from "./SubmitBtn.vue?vue&type=script&lang=js"
export * from "./SubmitBtn.vue?vue&type=script&lang=js"

import "./SubmitBtn.vue?vue&type=style&index=0&id=bb1d099c&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\jimoty\\JimotyWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1d099c"]])

export default __exports__